import React from 'react';
import { Container } from '../ui/Container';
import { Section } from '../ui/Section';
import { Button } from '../ui/Button';
import { FileWarning, Check } from 'lucide-react';
export function ArtworkGuidance() {
  return <Section className="bg-white border-y border-gray-100" data-id="element-130">
      <Container data-id="element-131">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-132">
          {/* Left: Specs */}
          <div data-id="element-133">
            <h2 className="text-3xl font-bold text-gray-900 mb-6" data-id="element-134">
              Artwork & file guidelines
            </h2>
            <p className="text-gray-600 mb-8" data-id="element-135">
              To ensure the best possible print result, please follow these
              guidelines when preparing your files.
            </p>

            <div className="bg-gray-50 rounded-xl p-6 border border-gray-100" data-id="element-136">
              <h3 className="font-semibold text-gray-900 mb-4 flex items-center" data-id="element-137">
                <FileWarning className="h-5 w-5 mr-2 text-cyan-600" data-id="element-138" />
                What we need
              </h3>
              <ul className="space-y-3" data-id="element-139">
                {['Accepted formats: PDF, AI, EPS, High-res JPEG', 'Include 3mm bleed on all sides', 'Convert all fonts to outlines/curves', 'Ensure colours are in CMYK mode', 'Images should be 300dpi at actual size'].map(item => <li key={item} className="flex items-start text-sm text-gray-700" data-id="element-140">
                    <Check className="h-4 w-4 text-green-500 mr-3 mt-0.5 flex-shrink-0" data-id="element-141" />
                    {item}
                  </li>)}
              </ul>
            </div>
          </div>

          {/* Right: Design Help */}
          <div className="bg-gray-900 rounded-2xl p-8 md:p-12 text-center text-white relative overflow-hidden" data-id="element-142">
            <div className="absolute top-0 right-0 -mr-16 -mt-16 w-64 h-64 bg-cyan-500 rounded-full mix-blend-overlay filter blur-3xl opacity-20" data-id="element-143"></div>
            <div className="absolute bottom-0 left-0 -ml-16 -mb-16 w-64 h-64 bg-pink-500 rounded-full mix-blend-overlay filter blur-3xl opacity-20" data-id="element-144"></div>

            <div className="relative z-10" data-id="element-145">
              <img src="https://cdn.magicpatterns.com/uploads/oRjVdEwcjrJByMjpUoNSga/cute-colour-inkling.png" alt="Inkling mascot ready to help" className="w-24 h-auto mx-auto mb-6 drop-shadow-lg" data-id="element-146" />
              <h3 className="text-2xl font-bold mb-4" data-id="element-147">Don't have artwork?</h3>
              <p className="text-gray-300 mb-8" data-id="element-148">
                No problem! Our in-house design team can help create
                professional, print-ready artwork for your project.
              </p>
              <Button variant="primary" onClick={() => document.getElementById('quote')?.scrollIntoView({
              behavior: 'smooth'
            })} data-id="element-149">
                Get Design Help
              </Button>
              <p className="text-xs text-gray-400 mt-4" data-id="element-150">
                Call us:{' '}
                <a href="tel:0894033306" className="text-cyan-400 hover:underline" data-id="element-151">
                  08 9403 3306
                </a>
              </p>
            </div>
          </div>
        </div>
      </Container>
    </Section>;
}